<template>
  <div :id="uuid + '-container'" style="position:relative">
    <div v-show="pasting" class="confirmDiv">
      Do you want to retain formatting of pasted content?
      <div class="flex">
        <button
          id="modal-logout-btn"
          class="btn btn-success mainBtn"
          @click.prevent="sanitizeContent(false)"
          aria-label="Yes"
        >
          Yes
        </button>
        <button
          id="modal-dismiss-btn"
          class="btn btn-default mainBtn"
          style="width: 100%"
          aria-label="No"
          @click.prevent="sanitizeContent(true)"
        >
          No
        </button>
      </div>
    </div>
    <div :class="{ pasting: pasting }">
      <editor
        :id="uuid"
        v-model="internalValue"
        :init="editorOptions"
        model-events="SetContent change keydown keyup blur focus paste"
      ></editor>
    </div>
    <div
      class="modal"
      :id="uuid + '-retain-markup-modal'"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      role="dialog"
    >
      <div
        :id="uuid + '-confirm-dialog-modal'"
        class="modal-dialog"
        style="position:fixed"
      >
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">
              Retain markup
            </h4>
          </div>
          <div class="modal-body">
            <div class="row marginBottom20">
              <div class="col-xs-12" style="text-align: center">
                <div>do you want to retain formatting of pasted content?</div>
              </div>
            </div>
            <div class="row">
              <div class="buttonGroup">
                <button
                  id="modal-logout-btn"
                  class="btn btn-success mainBtn paddingBottom10"
                  @click.prevent="sanitizeContent(false)"
                  aria-label="Yes"
                >
                  Yes
                </button>
                <button
                  id="modal-dismiss-btn"
                  class="btn btn-default mainBtn"
                  aria-label="No"
                  @click.prevent="sanitizeContent(true)"
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "tinymce/tinymce";
import "tinymce/icons/default";
import "tinymce/themes/silver";
import "tinymce/models/dom";
import "tinymce/skins/ui/oxide/skin.css";
require("tinymce/plugins/advlist");
require("tinymce/plugins/autolink");
require("tinymce/plugins/link");
require("tinymce/plugins/image");
require("tinymce/plugins/lists");
require("tinymce/plugins/charmap");
require("tinymce/plugins/preview");
require("tinymce/plugins/autoresize");
require("tinymce/plugins/code");
import Editor from "@tinymce/tinymce-vue";
import * as filestack from "filestack-js";
import { v4 as uuidv4 } from "uuid";
export default {
  props: {
    value: {
      type: String,
      required: false,
    },
    options: {
      type: Object,
      required: false,
      default: function() {
        return {};
      },
    },
    disabled: {
      type: Boolean,
      required: false,
      default:false,
    },
  },
  components: {
    Editor: Editor,
  },
  data() {
    return {
      uuid: "",
      filestack_client: null,
      internalValue: "",
      editorOptions: {},
      sanitizeOptions: {
        allowedTags:[],
        /*allowedTags: [
          "address",
          "article",
          "aside",
          "footer",
          "header",
          "h1",
          "h2",
          "h3",
          "h4",
          "h5",
          "h6",
          "hgroup",
          "main",
          "nav",
          "section",
          "blockquote",
          "dd",
          "div",
          "dl",
          "dt",
          "figcaption",
          "figure",
          //"hr",
          "li",
          "main",
          "ol",
          "p",
          "pre",
          "ul",
          //"a",
          "abbr",
          //"b",
          "bdi",
          "bdo",
          "br",
          "cite",
          "code",
          "data",
          "dfn",
          "em",
          //"i",
          "kbd",
          "mark",
          "q",
          "rb",
          "rp",
          "rt",
          "rtc",
          "ruby",
          "s",
          "samp",
          "small",
          "span",
          //"strong",
          "sub",
          "sup",
          "time",
          //"u",
          "var",
          "wbr",
          "caption",
          "col",
          "colgroup",
          "table",
          "tbody",
          "td",
          "tfoot",
          "th",
          "thead",
          "tr",
          //"img",
        ],*/
        disallowedTagsMode: "discard",
        allowedAttributes: {
          a: ["href"],
        },
        // Lots of these won't come up by default because we don't allow them
        selfClosing: [
          "img",
          "br",
          "hr",
          "area",
          "base",
          "basefont",
          "input",
          "link",
          "meta",
        ],
        // URL schemes we permit
        allowedSchemes: ["http", "https", "ftp", "mailto", "tel"],
        allowedSchemesByTag: {},
        allowedSchemesAppliedToAttributes: ["href", "src", "cite"],
        allowProtocolRelative: true,
        enforceHtmlBoundary: false,
        parseStyleAttributes: true,
      },
      contentToSanitize: "",
      pasting: false,
    };
  },
  created() {
    this.internalValue = this.value;
    this.uuid = "editor-" + uuidv4();
    this.init();
  },
  methods: {
    getOffset(el) {
      var _x = 0;
      var _y = 0;
      while (el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)) {
        _x += el.offsetLeft;
        _y += el.offsetTop;
        el = el.offsetParent;
      }
      return { top: _y, left: _x };
    },
    sanitizeContent(sanitize = true) {
      this.pasting = false;
      let currentContent = tinymce.get(this.uuid).getContent();
      if (sanitize) {
        tinymce
          .get(this.uuid)
          .setContent(
            currentContent +
              this.$sanitize(this.contentToSanitize, this.sanitizeOptions)
          );
      } else {
        this.contentToSanitize = this.contentToSanitize.replace(
          /<img[^>"']*((("[^"]*")|('[^']*'))[^"'>]*)*>/g,
          ""
        );
        tinymce
          .get(this.uuid)
          .setContent(currentContent + this.contentToSanitize);
      }
      //$("#" + this.uuid + "-retain-markup-modal").modal("hide");
    },
    uploadImageToEditor(callback, value, meta) {
      this.filestack_client
        .picker({
          accept: [".jpg", ".jpeg", ".gif", ".png", ".heic"],
          maxFiles: 1,
          uploadInBackground: false,
          onFileUploadFinished: function(file) {
            callback(file.url, { alt: file.filename });
          },
          onFileSelected(file) {
            console.log(file);
            // It's important to return a new file by the end of this function.
            //return { ...file, name: 'foo' };
          },
        })
        .open();
    },
    init() {
      var that = this;
      this.filestack_client = filestack.init(
        process.env.VUE_APP_FILESTACK_API_KEY
      );
      this.editorOptions = {
        content_css: "/src/sass/components/layout.scss",
        skin: false,
        selector: "textarea",
        min_height: _.get(this.options, "min_height"),
        // max_height: _.get(this.options, "max_height"),
        plugins: _.get(
          this.options,
          "plugins",
          "advlist autolink link image lists charmap preview autoresize code"
        ),
        autoresize_overflow_padding: 5,
        autoresize_bottom_margin: 25,
        external_plugins: {
          mathjax: "/plugins/@dimakorotkov/tinymce-mathjax/plugin.js",
        },
        mathjax: {
          lib: "/mathjax/es5/tex-mml-chtml.js", //required path to mathjax
          symbols: { start: "\\(", end: "\\)" }, //optional: mathjax symbols
          //className: "math-tex", //optional: mathjax element class
          configUrl: "/plugins/@dimakorotkov/tinymce-mathjax/config.js", //optional: mathjax config js
        },
        toolbar1: _.get(
          this.options,
          "toolbar1",
          "subscript superscript | cut copy pastetext | code | mathjax"
        ),
        toolbar2: _.get(
          this.options,
          "toolbar2",
          "undo redo | styleselect | bold italic removeformat underline strikethrough | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | table | fontsizeselect | image | link "
        ),
        menubar: false,
        file_picker_callback: function(callback, value, meta) {
          that.uploadImageToEditor(callback, value, meta);
        },
        default_link_target: "_blank",
        image_dimensions: false,
        paste_preprocess: function(plugin, args) {
          that.pasting = true;
          that.contentToSanitize = args.content;
          args.content = "";
          let container = $("#" + that.uuid + "-container")[0];
          var rect = container.getBoundingClientRect();
          let a = $(container).find("div.confirmDiv")[0];
          if (a) {
            $(a).css("top", rect.height / 2);
            $(a).css("width", rect.width);
          }
          /*var offset = that.getOffset(container);
          $(`#${that.uuid}-confirm-dialog-modal`).css(
            "top",
            window.innerWidth / 2
          );
          $(`#${that.uuid}-confirm-dialog-modal`).css(
            "left",
            window.innerHeight / 2
          );
          that.$nextTick(function() {
            $(`#${that.uuid}-retain-markup-modal`).modal("show");
          });*/
          that.pasting = true;
        },
        /*init_instance_callback: function(editor) {
          editor.on("BeforeSetContent", function(e) {
            e.content = e.content.trim();
            let sanitizedContent = that.$sanitize(
              e.content,
              that.sanitizeOptions
            );
            e.content = sanitizedContent;
          });
        },*/
        setup: (editor) => {
          editor.on('init', (e) => {
            let a = this.disabled?'readonly':'design'
            editor.mode.set(a);
          });
        }
      };
    },
  },
  watch: {
    internalValue: {
      handler: function() {
        var that = this;
        this.$emit("input", this.internalValue);
        /*Vue.nextTick(function() {
          that.parseMath();
        });*/
      },
      deep: true,
    },
    value: {
      handler: function() {
        this.internalValue = this.value;
        var that = this;
        /*Vue.nextTick(function() {
          that.parseMath();
        });*/
      },
      deep: true,
    },
    disabled:{
      handler:function(){
        let a = this.disabled?'readonly':'design'
        tinymce.get(this.uuid).mode.set(a);
      },
      deep:true
    }
  },
  mounted() {
    /*Focus issue on chrome fix*/
    $(document).on("focusin", function(e) {
      if ($(e.target).closest(".mce-window").length) {
        e.stopImmediatePropagation();
      }
    });
  },
};
</script>
<style>
.tox-statusbar__branding {
  display: none;
}
.wrs_imageContainer.wrs_button {
  padding: 0px !important;
}
.mce-notification.mce-in {
  opacity: 0 !important;
}
div[aria-label="Insert link"] .mce-btn.mce-open {
  display: none;
}
</style>
<style scoped>
.confirmDiv {
  position: absolute;
  z-index: 1;
}
.pasting {
  opacity: 0.2;
}
</style>
